import React, { useMemo } from "react";
import { CardElement } from "@stripe/react-stripe-js";

/**
 * CardSection - Stripe's card input, dressed to match everything else.
 *
 * CardElement renders in a cross-origin iframe, so it cannot inherit
 * page CSS and has to be handed literal colours. Reading them back off
 * the design tokens keeps it in step with the theme instead of pinning
 * it to one palette the way the hard-coded Stripe sample did.
 */
const CardSection = ({ onChange }) => {
  const options = useMemo(() => {
    const root =
      typeof window !== "undefined" && window.getComputedStyle
        ? window.getComputedStyle(document.documentElement)
        : null;
    const token = (name, fallback) => {
      const value = root ? (root.getPropertyValue(name) || "").trim() : "";
      return value || fallback;
    };

    return {
      style: {
        base: {
          color: token("--color-text-primary", "#0f172a"),
          fontFamily: token("--font-family-sans", "system-ui, sans-serif"),
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": { color: token("--color-text-subtle", "#94a3b8") },
        },
        invalid: {
          color: token("--color-accent-danger-fg", "#b91c1c"),
          iconColor: token("--color-accent-danger", "#ef4444"),
        },
      },
    };
  }, []);

  return (
    <div className="paymentCardField">
      <CardElement onChange={onChange} options={options} />
    </div>
  );
};

export default CardSection;
